import React, { FC, useEffect, useState } from 'react';
import { Title } from 'components/organisms/header';
import { useTranslation } from 'react-i18next';
import Loading from 'components/atoms/Loading';
import { SimpleEmployeeModel, SimpleEmployerEmployeeModel, useEmployerEmployees } from 'hooks/employerEmployees';
import { Formik, FormikHelpers, Form } from 'formik';
import { CreateCustomInvoiceModel, useBookings } from 'hooks/booking';
import { toFormikErrors } from 'utils/errorhelper';
import { FormGroup, FormikFormControl, FormikFormSelect } from 'components/atoms/form';
import FormikFormCurrency from 'components/atoms/form/FormCurrency/formik';
import { Button } from 'components/atoms/button';


const AdminCustomInvoices: FC = () => {

    const { t } = useTranslation('adminCustomInvoices');

    const [employers, setEmployers] = useState<SimpleEmployerEmployeeModel[]>([]);
    const { getSimpleEmployerEmployees } = useEmployerEmployees();
    const { createCustomInvoice } = useBookings();
    const [employees, setEmployees] = useState<SimpleEmployeeModel[]>([]);
    const [loading, setLoading] = useState<boolean>(false);
    const [isSubmitting, setIsSubmitting] = useState<boolean>(false);

    const initialValues: CreateCustomInvoiceModel = {
        employerId: '',
        employeeId: '',
        grossAmount: 0,
        description: ''
    };

    const fetchEmployersEmployees = async () => {
        setLoading(true);
        const response = await getSimpleEmployerEmployees();
        if (response.data) {
            setEmployers(response.data);
        }
        setLoading(false);
    };

    const changeSelectedEmployer = (selectedEmployerId: string) => {
        const selectedEmployer = employers.find((e) => e.employerId === selectedEmployerId);
        if (selectedEmployer !== undefined) {
            setEmployees(selectedEmployer.employees);
        }
    };

    useEffect(() => {
        fetchEmployersEmployees();
    }, []);

    const submit = async (values: CreateCustomInvoiceModel, actions: FormikHelpers<CreateCustomInvoiceModel>) => {
        setIsSubmitting(true);
        actions.setSubmitting(true);
        const response = await createCustomInvoice(values);

        if (!response.ok && response.errors) {
            const errors = toFormikErrors<CreateCustomInvoiceModel>(response.errors, t);
            actions.setErrors(errors);
        }

        actions.setSubmitting(false);
        setIsSubmitting(false);
    };

    return (
        <>
            <Title title={t('title')} />
            {loading === true ? <Loading /> :
                <Formik<CreateCustomInvoiceModel>
                    initialValues={initialValues}
                    onSubmit={submit}
                >
                    <Form>
                        <FormGroup label={t('form.employer')}>
                            <FormikFormSelect name={'employerId'} options={employers.map((e) => ({ title: e.employerName, value: e.employerId }))} afterChange={(e: string) => changeSelectedEmployer(e)} />
                        </FormGroup>

                        <FormGroup label={t('form.employee')}>
                            <FormikFormSelect name={'employeeId'} options={employees.map((e) => ({ title: e.employeeName, value: e.employeeId }))} />
                        </FormGroup>

                        <FormGroup label={t('form.grossAmount')}>
                            <FormikFormCurrency name={'grossAmount'} defaultValue={'0'} />
                        </FormGroup>

                        <FormGroup label={t('form.description')}>
                            <FormikFormControl name={'description'} />
                        </FormGroup>

                        <Button title={t('form.confirm')} type="submit" disabled={isSubmitting} />
                    </Form>
                </Formik>
            }


        </>
    );

};

export default AdminCustomInvoices;